/* eslint-disable react/prefer-stateless-function */
import "../../css/components/Arrow.scss";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Parser } from "html-to-react";
import Svg from "./Svg";

const htmlParser = new Parser(React);

class Arrow extends Component {
  handleClick = e => {
    if (this.props.onclick) {
      this.props.onclick(e);
    }
  };

  render = () => {
    /* eslint-disable max-len */
    const arrows = {
      right: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 129 129"><g><path d="M34.6,7.6c-1.6,1.6-1.6,4.2,0,5.8l51.1,51l-51.1,51.1c-1.6,1.6-1.6,4.2,0,5.8s4.2,1.6,5.8,0l53.9-53.9c0.8-0.8,1.2-1.8,1.2-2.9c0-1-0.4-2.1-1.2-2.9L40.4,7.7C38.8,6,36.2,6,34.6,7.6z"/></g></svg>`,
      left: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 129 129"><g><path d="M94.3,121.3c1.6-1.6,1.6-4.2,0-5.8l-51.1-51l51.1-51.1c1.6-1.6,1.6-4.2,0-5.8s-4.2-1.6-5.8,0L34.6,61.5c-0.8,0.8-1.2,1.8-1.2,2.9c0,1,0.4,2.1,1.2,2.9l53.9,53.9C90.1,122.9,92.7,122.9,94.3,121.3z"/></g></svg>`,
      up: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 129 129"><g><path d="M7.6,94.3c1.6,1.6,4.2,1.6,5.8,0l51-51.1l51.1,51.1c1.6,1.6,4.2,1.6,5.8,0c1.6-1.6,1.6-4.2,0-5.8L67.4,34.6c-0.8-0.8-1.8-1.2-2.9-1.2c-1,0-2.1,0.4-2.9,1.2L7.7,88.5C6,90.1,6,92.7,7.6,94.3z"/></g></svg>`,
      down: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 129 129"><g><path d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"></path></g></svg>`,
    };

    const text = htmlParser.parse(this.props.text);

    const styles = this.props.styles;

    const attrs = {
      ...this.props.attrs,
    };

    const direction = this.props.customProps.direction;

    return (
      <div className={`wrapper ${this.props.filters.devices.join("")}`}>
        <p {...attrs} style={{ ...styles }} onClick={e => this.handleClick(e)}>
          {Object.entries(arrows).map(([i, x]) => {
            const template = (
              <span className={`arrow arrow-${i}`} key={i}>
                <Svg svg={x} />
              </span>
            );
            if (direction && direction === i) {
              return template;
            } else if (!direction) {
              return template;
            }
            return null;
          })}
          <span className="text-arrow">{text}</span>
        </p>
      </div>
    );
  };
}

Arrow.defaultProps = {
  customProps: {
    direction: null,
  },
  attributes: {},
  content: "",
  attrs: {},
  styles: {},
};

Arrow.propTypes = {
  attributes: PropTypes.object,
  attrs: PropTypes.object,
  styles: PropTypes.object,
};

export default Arrow;
